



import {
  defineComponent,
  onMounted,
  onUnmounted,
  toRefs,
  nextTick,
  watch,
  getCurrentInstance,
} from '@vue/composition-api';
import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
} from 'echarts/components';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import i18n, { i18n_t } from '@/locales/i18n';

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LineChart,
  PieChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
]);
export default defineComponent({
  props: {
    options: {
      type: Object,
      default: {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { options, loading } = toRefs(props);
    let chart: null | echarts.ECharts = null;
    const chartResize = () => {
      if (!chart) return;
      (chart as echarts.ECharts).resize();
    };
    onMounted(() => {
      nextTick(() => {
        chart = echarts.init(context.refs.smhChart as HTMLElement);
        if (loading.value) {
          (chart as echarts.ECharts).showLoading({
            text: i18n_t('数据加载中'),
            maskColor: '#fff',
          });
        }
        if (options.value.series.length === 0) return;
        chart.setOption(options.value);
      });
      window.addEventListener('resize', chartResize);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', chartResize);
      echarts.dispose(chart as echarts.ECharts);
      chart = null;
    });
    watch(
      () => props.options,
      val => {
        (chart as echarts.ECharts).setOption(options.value);
      },
      {
        deep: true,
      },
    );
    watch(
      () => props.loading,
      val => {
        if (val) {
          (chart as echarts.ECharts).showLoading({
            text: i18n_t('数据加载中'),
            maskColor: '#fff',
          });
        } else {
          (chart as echarts.ECharts).hideLoading();
        }
      },
      {
        deep: true,
      },
    );
    return {};
  },
});
